
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { required } from "vuelidate/lib/validators";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      finalOutcome: "declined",
      comment: ""
    };
  },
  computed: {
    task() {
      return store.state.application.requestForCallbackTask;
    },
    showModal: {
      get(): any {
        return !!this.task;
      },
      set(value: any) {
        if (!value) {
          store.commit(
            APPLICATION.NS(APPLICATION.MUTATIONS.SET_REQUEST_FOR_CALLBACK_TASK),
            null
          );
          this.resetForm();
        }
      }
    },
    ...mapState({
      applicationName: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.businessName,
      fullName: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.callbackDetails &&
        state.applicationData.callbackDetails.fullName,
      email: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.callbackDetails &&
        state.applicationData.callbackDetails.email,
      contactNumber: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.callbackDetails &&
        state.applicationData.callbackDetails.contactNumber
    })
  },
  methods: {
    async onComplete() {
      this.isLoading = true;

      const comment = this.comment;
      const taskId = this.task.taskId;
      const action =
        this.finalOutcome === "completed"
          ? APPLICATION.NS(APPLICATION.ACTIONS.COMPLETED_APPLICATION)
          : APPLICATION.NS(APPLICATION.ACTIONS.DECLINE_CALLBACK_OUTCOME);

      const success = await store.dispatch(action, { taskId, comment });

      this.isLoading = false;
      if (success) {
        // hide modal and reset form values
        this.showModal = false;
        this.resetForm();
        // TODO: for now refresh page, could look at updating the task state manually
        window.location = window.location;
      }
    },
    resetForm() {
      this.finalOutcome = "declined";
      this.comment = "";
    }
  },
  validations: {
    comment: {
      required
    }
  }
});
